import LabelRecontagem from "@base/LabelRecontagem/LabelRecontagem"

export default LabelRecontagem;
